import { lang } from 'zf-infra';
import { modal } from '../feedback';
import { Box } from '../box';
import { t } from '../i18n';
import type { ConfirmProps } from './types';


const renderArrayContent = (arrayContent: string[]) => (
  <Box>
    {arrayContent.map((content, index) => (
      <Box key={index}>{content}</Box>
    ))}
  </Box>
);

/**
 * 封装antd 的Confirm方法
 * @param props ConfirmProps
 */
export async function confirm(props: ConfirmProps): Promise<boolean> {
  const {
    okText = t('确定'),
    cancelText = t('取消'),
    okType = 'danger',
    content
  } = props;
  return await new Promise(resolve => {
    modal.confirm({
      ...props,
      content: Array.isArray(content) ? renderArrayContent(content) : content,
      icon: null,
      okText,
      okType,
      cancelText,
      onOk: (close): void => {
        lang.debounce(() => {
          close();
          resolve(true);
        }, 300)();
      },
      onCancel: (close): void => {
        lang.debounce(() => {
          close();
          resolve(false);
        }, 300)();
      }
    });
  });
}
